import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router-dom";
import { Col, Collapse, Row } from "reactstrap";

// Import Data
import navdata from "../LayoutMenuData";
//i18n
import { withTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import "./layout.styles.css";

// Change #100683 - "why does this keep opening a new tab" (My Vehicles). A
// company-made (placeholder) menu item used to open in a new tab whatever it
// pointed at. Only a link to another site does now; an in-app route such as
// /my-vehicles navigates in the same tab like every other menu item.
const isExternalMenuLink = (item) => {
  if (!item?.FlagPlaceholder) return false;
  const link = String(item?.link || "").trim();
  if (!/^(https?:)?\/\//i.test(link)) return false;
  try {
    return new URL(link, window.location.href).origin !== window.location.origin;
  } catch (e) {
    return true;
  }
};
// A placeholder's link is the Url exactly as typed in the menu builder
// ("my-vehicles", "/my-vehicles" or a full URL on this site); in-app ones get
// a clean "/path" so the router does not resolve them relative to the page.
const normaliseMenuLinks = (items) =>
  (items || []).forEach((item) => {
    if (item?.FlagPlaceholder && item.link && !isExternalMenuLink(item)) {
      let link = String(item.link).trim();
      if (/^(https?:)?\/\//i.test(link)) {
        try {
          const url = new URL(link, window.location.href);
          link = url.pathname + url.search + url.hash;
        } catch (e) {
          // leave as typed
        }
      } else if (!link.startsWith("/") && !link.startsWith("#")) {
        link = "/" + link;
      }
      item.link = link;
    }
    normaliseMenuLinks(item?.subItems);
    normaliseMenuLinks(item?.childItems);
  });
const HorizontalLayout = (props) => {
  const [isMoreMenu, setIsMoreMenu] = useState(false);
  const navData = navdata().props.children;
  if (Array.isArray(navData)) normaliseMenuLinks(navData);
  let menuItems = [];
  let splitMenuItems = [];
  let menuSplitContainer = navData?.length;
  if (!isEmpty(navData) && Array.isArray(navData)) {
    // if navData is not an array  return empty array

    navData?.forEach(function (value, key) {
      if (value["isHeader"]) {
        menuSplitContainer++;
      }
      if (key >= menuSplitContainer) {
        let val = value;
        val.childItems = value.subItems;
        val.isChildItem = !!value.subItems;
        delete val.subItems;
        splitMenuItems.push(val);
      } else {
        menuItems.push(value);
      }
      // if subItems is not empty
    });
  }

  // menuItems.push({ id: 'more', label: 'More', icon: 'ri-briefcase-2-line', link: "/#", stateVariables: isMoreMenu, subItems: splitMenuItems, click: function (e) { e.preventDefault(); setIsMoreMenu(!isMoreMenu); }, });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const initMenu = () => {
      const pathName = process.env.PUBLIC_URL + props.location.pathname;
      const ul = document.getElementById("navbar-nav");
      const items = ul.getElementsByTagName("a");
      let itemsArray = [...items]; // converts NodeList to Array
      removeActivation(itemsArray);
      let matchingMenuItem = itemsArray.find((x) => {
        return x.pathname === pathName;
      });
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [props.location.pathname, props.layoutType]);

  function activateParentDropdown(item) {
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

    if (parentCollapseDiv) {
      // to set aria expand true remaining
      parentCollapseDiv.classList.add("show");
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      parentCollapseDiv.parentElement.children[0].setAttribute(
        "aria-expanded",
        "true"
      );
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement
          .closest(".collapse")
          .classList.add("show");
        var parentElementDiv =
          parentCollapseDiv.parentElement.closest(
            ".collapse"
          ).previousElementSibling;
        if (parentElementDiv)
          if (parentElementDiv.closest(".collapse"))
            parentElementDiv.closest(".collapse").classList.add("show");
        parentElementDiv.classList.add("active");
        var parentElementSibling =
          parentElementDiv.parentElement.parentElement.parentElement
            .previousElementSibling;
        if (parentElementSibling) {
          parentElementSibling.classList.add("active");
        }
      }
      return false;
    }
    return false;
  }

  const removeActivation = (items) => {
    let actiItems = items.filter((x) => x.classList.contains("active"));

    actiItems.forEach((item) => {
      if (item.classList.contains("menu-link")) {
        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  };
  const [clickedItem, setClickedItem] = useState([]);
  const handleMenuClick = (e, item) => {
    e.preventDefault();
    // Check if item exists inside array
    if (clickedItem.includes(item)) {
      // Remove item from array
      setClickedItem(clickedItem.filter((i) => i !== item));
    }
    // Add item to array
    else {
      setClickedItem([...clickedItem, item]);
    }
  };

  //Toggle menu close on click
  const toogleMenuBtn = () => {
    var windowSize = document.documentElement.clientWidth;

    if (windowSize > 767)
      document.querySelector(".hamburger-icon").classList.toggle("open");

    //For collapse horizontal menu
    if (document.documentElement.getAttribute("data-layout") === "horizontal") {
      document.body.classList.contains("menu")
        ? document.body.classList.remove("menu")
        : document.body.classList.add("menu");
    }

    //For collapse vertical menu
    if (document.documentElement.getAttribute("data-layout") === "vertical") {
      if (windowSize < 1025 && windowSize > 767) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "sm"
          ? document.documentElement.setAttribute("data-sidebar-size", "")
          : document.documentElement.setAttribute("data-sidebar-size", "sm");
      } else if (windowSize > 1025) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "lg"
          ? document.documentElement.setAttribute("data-sidebar-size", "sm")
          : document.documentElement.setAttribute("data-sidebar-size", "lg");
      } else if (windowSize <= 767) {
        document.body.classList.toggle("vertical-sidebar-enable");
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
    }

    //Two column menu
    if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
      document.body.classList.contains("twocolumn-panel")
        ? document.body.classList.remove("twocolumn-panel")
        : document.body.classList.add("twocolumn-panel");
    }
  };

  return (
    <React.Fragment>
      {(menuItems || []).map((item, key) => {
        return (
          <React.Fragment key={key}>
            {/* Main Header */}
            {!item["isHeader"] ? (
              item.subItems ? (
                <li className="nav-item">
                  {isExternalMenuLink(item) ? (
                    <>
                      <a
                        href={item.link ? item.link : "#"}
                        className="nav-link menu-link"
                        data-bs-toggle="collapse"
                        target={isExternalMenuLink(item) && "_blank"}
                        onClick={(e) => {
                          handleMenuClick(e, item.id);
                          item.subItems.length === 0 && toogleMenuBtn();
                        }}
                      >
                        <i className={item.icon}></i>{" "}
                        <span data-key="t-apps">{item.label}</span>
                      </a>
                    </>
                  ) : (
                    <Link
                      className="nav-link menu-link"
                      to={item.link ? item.link : "#"}
                      data-bs-toggle="collapse"
                      target={isExternalMenuLink(item) && "_blank"}
                      onClick={(e) => {
                        handleMenuClick(e, item.id);
                        item.subItems.length === 0 && toogleMenuBtn();
                      }}
                    >
                      <i className={item.icon}></i>{" "}
                      <span data-key="t-apps">{item.label}</span>
                    </Link>
                  )}
                  <Collapse
                    className={
                      item.subItems.length > 13
                        ? "menu-dropdown mega-dropdown-menu mobile-menu-main-collapse-frame"
                        : "menu-dropdown mobile-menu-main-collapse-frame"
                    }
                    isOpen={
                      //check if item exist inside clickedItem
                      clickedItem.includes(item.id)
                    }
                    id="sidebarApps"
                  >
                    {/* 2nd menu Level */}
                    {item.subItems.length > 13 ? (
                      <React.Fragment>
                        <Row>
                          {item.subItems &&
                            (item.subItems || []).map((subItem, key) => (
                              <React.Fragment key={key}>
                                {key % 2 === 0 ? (
                                  <Col lg={4}>
                                    <ul className="nav nav-sm flex-column">
                                      <li className="nav-item">
                                        {isExternalMenuLink(subItem) ? (
                                          <a
                                            href={item.subItems[key].link}
                                            onClick={() => {
                                              !subItem.isChildItem &&
                                                toogleMenuBtn();
                                            }}
                                            target={
                                              isExternalMenuLink(subItem) &&
                                              "_blank"
                                            }
                                            className="nav-link"
                                          >
                                            <i
                                              className={
                                                item.subItems[key].icon
                                              }
                                            ></i>{" "}
                                            {item.subItems[key].label}
                                          </a>
                                        ) : (
                                          <Link
                                            onClick={() => {
                                              !subItem.isChildItem &&
                                                toogleMenuBtn();
                                            }}
                                            target={
                                              isExternalMenuLink(subItem) &&
                                              "_blank"
                                            }
                                            onTouchDown={() => {
                                              !subItem.isChildItem &&
                                                toogleMenuBtn();
                                            }} //for touch devices
                                            to={item.subItems[key].link}
                                            className="nav-link"
                                          >
                                            <i
                                              className={
                                                item.subItems[key].icon
                                              }
                                            ></i>{" "}
                                            {item.subItems[key].label}
                                          </Link>
                                        )}
                                      </li>
                                    </ul>
                                  </Col>
                                ) : (
                                  <Col lg={4}>
                                    <ul className="nav nav-sm flex-column">
                                      <li className="nav-item">
                                        {isExternalMenuLink(subItem) ? (
                                          <a
                                            href={item.subItems[key].link}
                                            target={
                                              isExternalMenuLink(subItem) &&
                                              "_blank"
                                            }
                                            onClick={() => {
                                              !subItem.isChildItem &&
                                                toogleMenuBtn();
                                            }}
                                            className="nav-link"
                                          >
                                            <i
                                              className={
                                                item.subItems[key].icon
                                              }
                                            ></i>{" "}
                                            {item.subItems[key].label}
                                          </a>
                                        ) : (
                                          <Link
                                            target={
                                              isExternalMenuLink(subItem) &&
                                              "_blank"
                                            }
                                            onClick={() => {
                                              !subItem.isChildItem &&
                                                toogleMenuBtn();
                                            }}
                                            to={item.subItems[key].link}
                                            className="nav-link"
                                          >
                                            <i
                                              className={
                                                item.subItems[key].icon
                                              }
                                            ></i>{" "}
                                            {item.subItems[key].label}
                                          </Link>
                                        )}
                                      </li>
                                    </ul>
                                  </Col>
                                )}
                              </React.Fragment>
                            ))}
                        </Row>
                      </React.Fragment>
                    ) : (
                      <ul className="nav nav-sm flex-column test">
                        {item.subItems &&
                          (item.subItems || []).map((subItem, key) => (
                            <React.Fragment key={key}>
                              {!subItem.isChildItem ? (
                                <li className="nav-item">
                                  {isExternalMenuLink(subItem) ? (
                                    <a
                                      href={subItem.link ? subItem.link : "/#"}
                                      target={
                                        isExternalMenuLink(subItem) && "_blank"
                                      }
                                      className="nav-link"
                                      onClick={() => {
                                        !subItem.isChildItem && toogleMenuBtn();
                                      }}
                                    >
                                      <i className={props.t(subItem.icon)}></i>{" "}
                                      {props.t(subItem.label)}
                                    </a>
                                  ) : (
                                    <Link
                                      target={
                                        isExternalMenuLink(subItem) && "_blank"
                                      }
                                      to={subItem.link ? subItem.link : "/#"}
                                      className="nav-link"
                                      onClick={() => {
                                        !subItem.isChildItem && toogleMenuBtn();
                                      }}
                                    >
                                      <i className={props.t(subItem.icon)}></i>{" "}
                                      {props.t(subItem.label)}
                                    </Link>
                                  )}
                                </li>
                              ) : (
                                <li className="nav-item">
                                  {isExternalMenuLink(subItem) ? (
                                    <a
                                      href={"/#"}
                                      target={
                                        isExternalMenuLink(subItem) && "_blank"
                                      }
                                      onClick={(e) => {
                                        handleMenuClick(e, subItem.id);
                                        !subItem.isChildItem && toogleMenuBtn();
                                      }}
                                      className="nav-link"
                                      data-bs-toggle="collapse"
                                    >
                                      <i className={props.t(subItem.icon)}></i>{" "}
                                      {props.t(subItem.label)}
                                    </a>
                                  ) : (
                                    <Link
                                      target={
                                        isExternalMenuLink(subItem) && "_blank"
                                      }
                                      onClick={(e) => {
                                        handleMenuClick(e, subItem.id);
                                        !subItem.isChildItem && toogleMenuBtn();
                                      }}
                                      className="nav-link"
                                      to="/#"
                                      data-bs-toggle="collapse"
                                    >
                                      <i className={props.t(subItem.icon)}></i>{" "}
                                      {props.t(subItem.label)}
                                    </Link>
                                  )}
                                  <Collapse
                                    className="menu-dropdown"
                                    isOpen={
                                      // check if item exist inside clickedItem
                                      clickedItem.includes(subItem.id)
                                    }
                                    id="sidebarEcommerce"
                                  >
                                    <ul className="nav nav-sm flex-column">
                                      {/* child subItms  */}
                                      {subItem.childItems &&
                                        (subItem.childItems || []).map(
                                          (subChildItem, key) => (
                                            <React.Fragment key={key}>
                                              {!subChildItem.childItems ? (
                                                <li className="nav-item">
                                                  {isExternalMenuLink(subItem) ? (
                                                    <a
                                                      href={
                                                        subChildItem.link
                                                          ? subChildItem.link
                                                          : "/#"
                                                      }
                                                      target={
                                                        isExternalMenuLink(subItem) &&
                                                        "_blank"
                                                      }
                                                      onClick={() => {
                                                        toogleMenuBtn();
                                                      }}
                                                      className="nav-link"
                                                    >
                                                      {props.t(
                                                        subChildItem.label
                                                      )}
                                                    </a>
                                                  ) : (
                                                    <Link
                                                      target={
                                                        isExternalMenuLink(subItem) &&
                                                        "_blank"
                                                      }
                                                      onClick={() => {
                                                        toogleMenuBtn();
                                                      }}
                                                      to={
                                                        subChildItem.link
                                                          ? subChildItem.link
                                                          : "#"
                                                      }
                                                      className="nav-link"
                                                    >
                                                      {props.t(
                                                        subChildItem.label
                                                      )}
                                                    </Link>
                                                  )}
                                                </li>
                                              ) : (
                                                <li className="nav-item">
                                                  {isExternalMenuLink(subItem) ? (
                                                    <a
                                                      href={"/#"}
                                                      target={
                                                        isExternalMenuLink(subItem) &&
                                                        "_blank"
                                                      }
                                                      onClick={(e) => {
                                                        handleMenuClick(
                                                          e,
                                                          subChildItem.id
                                                        );
                                                      }}
                                                      className="nav-link"
                                                      data-bs-toggle="collapse"
                                                    >
                                                      {" "}
                                                      {props.t(
                                                        subChildItem.label
                                                      )}
                                                    </a>
                                                  ) : (
                                                    <Link
                                                      target={
                                                        isExternalMenuLink(subItem) &&
                                                        "_blank"
                                                      }
                                                      onClick={(e) => {
                                                        handleMenuClick(
                                                          e,
                                                          subChildItem.id
                                                        );
                                                      }}
                                                      className="nav-link"
                                                      to="/#"
                                                      data-bs-toggle="collapse"
                                                    >
                                                      {" "}
                                                      {props.t(
                                                        subChildItem.label
                                                      )}
                                                    </Link>
                                                  )}
                                                  <Collapse
                                                    className="menu-dropdown"
                                                    isOpen={
                                                      // check if item exist inside clickedItem
                                                      clickedItem.includes(
                                                        subChildItem.id
                                                      )
                                                    }
                                                    id="sidebarEcommerce"
                                                  >
                                                    <ul className="nav nav-sm flex-column">
                                                      {/* child subItms  */}
                                                      {subChildItem.childItems &&
                                                        (
                                                          subChildItem.childItems ||
                                                          []
                                                        ).map(
                                                          (
                                                            subSubChildItem,
                                                            key
                                                          ) => (
                                                            <li
                                                              className="nav-item apex"
                                                              key={key}
                                                            >
                                                              {isExternalMenuLink(subSubChildItem) ? (
                                                                <a
                                                                  href={
                                                                    subSubChildItem.link
                                                                      ? subSubChildItem.link
                                                                      : "/#"
                                                                  }
                                                                  target={
                                                                    isExternalMenuLink(subSubChildItem) &&
                                                                    "_blank"
                                                                  }
                                                                  onClick={() => {
                                                                    toogleMenuBtn();
                                                                  }}
                                                                  className="nav-link"
                                                                >
                                                                  {props.t(
                                                                    subSubChildItem.label
                                                                  )}
                                                                </a>
                                                              ) : (
                                                                <Link
                                                                  target={
                                                                    isExternalMenuLink(subSubChildItem) &&
                                                                    "_blank"
                                                                  }
                                                                  onClick={() => {
                                                                    toogleMenuBtn();
                                                                  }}
                                                                  to={
                                                                    subSubChildItem.link
                                                                      ? subSubChildItem.link
                                                                      : "/#"
                                                                  }
                                                                  className="nav-link"
                                                                >
                                                                  {props.t(
                                                                    subSubChildItem.label
                                                                  )}
                                                                </Link>
                                                              )}
                                                            </li>
                                                          )
                                                        )}
                                                    </ul>
                                                  </Collapse>
                                                </li>
                                              )}
                                            </React.Fragment>
                                          )
                                        )}
                                    </ul>
                                  </Collapse>
                                </li>
                              )}
                            </React.Fragment>
                          ))}
                      </ul>
                    )}
                  </Collapse>
                </li>
              ) : (
                <li className="nav-item">
                  {isExternalMenuLink(item) ? (
                    <a
                      href={item.link ? item.link : "/#"}
                      target={isExternalMenuLink(item) && "_blank"}
                      onClick={() => {
                        toogleMenuBtn();
                      }}
                      className="nav-link menu-link"
                    >
                      <i className={item.icon}></i>{" "}
                      <span>{props.t(item.label)}</span>
                    </a>
                  ) : (
                    <Link
                      target={isExternalMenuLink(item) && "_blank"}
                      onClick={() => {
                        toogleMenuBtn();
                      }}
                      className="nav-link menu-link"
                      to={item.link ? item.link : "/#"}
                    >
                      <i className={item.icon}></i>{" "}
                      <span>{props.t(item.label)}</span>
                    </Link>
                  )}
                </li>
              )
            ) : (
              <li className="menu-title">
                <span data-key="t-menu">{props.t(item.label)}</span>
              </li>
            )}
          </React.Fragment>
        );
      })}
      {/* menu Items */}
    </React.Fragment>
  );
};

HorizontalLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(HorizontalLayout));
